import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetPatientData,
	GetPatientDataModel,
	GetPatientDataParams,
} from 'domain/usecases/private/my-hospitalization/get-patient-data';

export class RemoteGetPatientData implements GetPatientData {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetPatientDataModel>,
	) {}

	async get({signal, ...params}: GetPatientDataParams): Promise<GetPatientDataModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
